import React, { Component } from 'react'
import { post } from '../../../utils/networking'
import $ from 'jquery'
import './style.css'
import * as Notification from '../../../notification'
import { getProfile, setVar } from './action'
import { connect } from 'react-redux'
import FileDropZone from '../../fileDropZone'
import { concatStatic } from 'rxjs/operator/concat';
import VirtualizedSelect from 'react-virtualized-select';
import 'react-select/dist/react-select.css'
import 'react-virtualized-select/styles.css'
export class Setting extends Component {

    constructor(props) {
        super(props)
        this.state = {
            photos: [],
            isShowPopup: false,
            birthdayDay: [],
            birthdayMonth: [],
            birthdayYear: [],
            selectDay: "",
            selectMonth: "",
            selectYear: "",
            birthday00: ""
        }
    }


    componentDidMount() {
        this.props.getProfile();
        //     let {
        //         birthdayDay,
        //         birthdayMonth,
        //         birthdayYear
        //     } = this.state
        //     for (var i = 1; i < 32; i++) {
        //         birthdayDay.push({ label: i, value: i })
        //         if (i < 13) {
        //             birthdayMonth.push({ label: i, value: i })
        //         }
        //     }
        //     for (var i = 1900; i < 2016; i++) {
        //         birthdayYear.push({ label: i, value: i })
        //     }
        //     this.setState({
        //         birthdayDay,
        //         birthdayMonth,
        //         birthdayYear,
        //     })
    }

    passwordUpdate() {
        Notification.hide();
        var newPass = {
            oldPassword: this.refs.old_pass.value,
            newPassword: this.refs.new_pass.value,
            confirmPassword: this.refs.re_pass.value
        }
        if (newPass.oldPassword === "" || newPass.newPassword === "" || newPass.confirmPassword === "") {
            if (newPass.oldPassword === "")
                Notification.show($("#old_pass"), "Empty", "fail", "1");
            if (newPass.newPassword === "")
                Notification.show($("#new_pass"), "Empty", "fail", "1");
            if (newPass.confirmPassword === "")
                Notification.show($("#re_pass"), "Empty", "fail", "1");
            Notification.show($("#change_pass_submit"), "Please fill out all fields.", "fail", "0");
        }
        else {
            if (newPass.newPassword == newPass.confirmPassword) {
                $("#change_pass_submit").html("<i class='fa fa-spinner fa-pulse'></i> Waiting...");
                post('user/changePassword', newPass, "customer", result => {
                    Notification.show($("#change_pass_submit"), "Your password has been change.", "success", "0");
                    $("#change_pass_submit").html("Save Password");
                }, errors => {
                    Notification.show($("#change_pass_submit"), errors.errors[0], "fail", "0");
                    $("#change_pass_submit").html("Save Password");
                })
            }
            else {
                Notification.show($("#re_pass"), "Password doesn't match.", "fail", "1");
            }
        }

    }

    resetFormAndClose() {
        Notification.hide();
        this.refs.old_pass.value = "";
        this.refs.new_pass.value = "";
        this.refs.re_pass.value = "";
        $(".password_update_form").toggleClass("show");
    }

    checkMail(mail) {
        var regExp = new RegExp("[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$");
        return regExp.test(mail);
    }

    profileUpdate() {
        Notification.hide();
        var newProfile = {
            name: this.refs.first_name.value,
            lastName: "",
            email: this.refs.user_mail.value.toLowerCase(),
            avatar: this.props.avatar,
            phone: this.refs.user_phone.value,
            address: this.refs.user_address.value,
            birthday: this.refs.user_birthday.value
        }
        if (newProfile.name === "" || newProfile.email === "" || newProfile.phone === "" || newProfile.address === "") {
            if (newProfile.name === "")
                Notification.show($(".first_name")[0], "Empty", "fail", "1");
            if (newProfile.email === "")
                Notification.show($("#user_mail"), "Empty", "fail", "1");
            if (newProfile.phone === "")
                Notification.show($("#user_phone"), "Empty", "fail", "1");
            if (newProfile.address === "")
                Notification.show($("#user_address"), "Empty", "fail", "1");
        }
        else {
            if (this.checkMail(newProfile.email)) {
                $("#update_profile_submit").html("<i class='fa fa-spinner fa-pulse'></i> Waiting...");
                post('user/updateProfile', newProfile, "customer", result => {
                    this.props.setVar(undefined, newProfile)
                    Notification.show($("#update_profile_submit"), "Your Profile has been update.", "success", "0");
                    $("#update_profile_submit").html("Save Profile");
                }, errors => {
                    Notification.show($("#update_profile_submit"), errors.errors[0], "fail", "0");
                    $("#update_profile_submit").html("Save Profile");
                })
            }
            else {
                Notification.show($("#update_profile_submit"), "Please match the requested email format.", "fail", "0");
            }
        }
    }

    handleUpdateAvatar() {
        Notification.hide();
        var newProfile = {
            firstName: this.props.name,
            lastName: "",
            email: this.props.email.toLowerCase(),
            avatar: (this.state.photos[0]) ? this.state.photos[0] : "",
            phone: (this.props.phone) ? this.props.phone : "",
            address: (this.props.address) ? this.props.address : "",
            birthday: (this.props.birthday) ? this.props.birthday : ""
        }
        if (newProfile.avatar != "") {
            $("#update-avatar-bt").html("<i class='fa fa-spinner fa-pulse'></i> Saving...");
            post('user/updateAvatar', { avatar: (this.state.photos[0]) ? this.state.photos[0] : "" }, "customer", result => {
                this.props.setVar(undefined, newProfile)
                Notification.show($("#update-avatar-bt"), "Your avatar has been update.", "success", "0");
                $("#update-avatar-bt").html("Saving");
            }, errors => {
                Notification.show($("#update-avatar-bt"), errors.errors[0], "fail", "0");
                $("#update-avatar-bt").html("Saving");
            })
        }
        else {
            Notification.show($("#update-avatar-bt"), "Please select your image!", "fail", "0");
        }
    }

    onAddPhoto(file) {
        const that = this;
        let { photos } = this.state;
        var reader = new FileReader();
        reader.onload = function (e) {
            photos = [];
            photos.push(e.target.result);
            that.setState({
                photos
            })
        }
        reader.readAsDataURL(file[0]);
    }
    onRemovePhoto() {
        const that = this;
        that.setState({
            photos: []
        })
    }

    render() {
        $("html, body").animate({ scrollTop: 0 }, 400);
        const {
            name,
            lastName,
            email,
            avatar,
            phone,
            address,
            birthday
        } = this.props

        let {
            isShowPopup,
            photos,
            birthdayDay,
            birthdayMonth,
            birthdayYear,
            selectDay
        } = this.state;
        return (
            <div className="setting">
                <div className="user_profile">
                    <p className="title">Profile Settings</p>
                    <div className="avatar">
                        <div className="avatar_image"
                            style={
                                {
                                    backgroundImage: "url(" + ((avatar === "") ? require('../../../assets/images/loader.gif') : avatar) + ")",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    backgroundSize: "cover"
                                }}>
                            <i className="fas fa-edit" onClick={() => this.setState({ isShowPopup: true })}></i>
                        </div>
                        {
                            (isShowPopup) ? <div className="upload-popup">
                                <div className="popup-content">
                                    <div className="content-header">
                                        <span className="title">Change your avatar</span>
                                        <i className="fas fa-times" onClick={() => this.setState({ isShowPopup: false })}></i>
                                    </div>
                                    <div className="form-group info">
                                        <label>Photo <span className="text-danger">*</span></label>
                                        <FileDropZone
                                            base64Code={photos}
                                            onAdd={this.onAddPhoto.bind(this)}
                                            onRemove={this.onRemovePhoto.bind(this)} />
                                        <span className={"text-danger"} id={"validator-for-photo"}></span>
                                    </div>
                                    <div className="content-footer">
                                        <span className="submit" id="update-avatar-bt" onClick={this.handleUpdateAvatar.bind(this)}>Save</span>
                                    </div>
                                </div>
                            </div> : ""
                        }
                    </div>
                    <div className="profile_detail">
                        <p>Name: &nbsp;&nbsp;&nbsp;&nbsp;<span>{(name) ? name : "" + " " + (lastName) ? lastName : ""}</span></p>
                        <p>Birthday:<span>{birthday}</span></p>
                        <p className="bd-description">
                            Why we need your DOB, because we will send you special discount on your birthday.
                        </p>
                        <p>Email: &nbsp;&nbsp;&nbsp;&nbsp;<span>{email}</span></p>
                        <p>Phone: &nbsp;&nbsp;&nbsp;<span>{phone}</span></p>
                        <p>Adress: &nbsp;&nbsp;<span>{address}</span></p>
                        <div className="update">
                            <ul className="menu">
                                <li onClick={() => {
                                    Notification.hide();
                                    $(".profile_update_form").toggleClass("show");
                                    this.refs.first_name.value = name;
                                    this.refs.user_mail.value = email;
                                    this.refs.user_phone.value = phone;
                                    this.refs.user_address.value = address;
                                    this.refs.user_birthday.value = birthday;
                                }}>Update Profile</li>
                                <li className="menu_space">|</li>
                                <li onClick={() => { $(".password_update_form").toggleClass("show") }}>Change Password</li>
                            </ul>
                            <div className="profile_update_form">
                                <div className="form">
                                    <div className="form_header">
                                        <span>Update Profile</span>
                                        <i className="fa fa-times" aria-hidden="true" onClick={() => { $(".profile_update_form").toggleClass("show") }}></i>
                                    </div>
                                    <div className="form_detail">
                                        <div id="user_info">
                                            <div className="first_name">
                                                <label>Full name</label>
                                                <input type="text" ref="first_name" placeholder="Full name" />
                                            </div>
                                        </div>
                                        <div id="user_birthday">
                                            <div className="user_bd">
                                                <label>Birthday</label>
                                                <div>
                                                    {/* <VirtualizedSelect options={birthdayDay} value={selectDay} />
                                                        <VirtualizedSelect options={birthdayMonth} />
                                                        <VirtualizedSelect options={birthdayYear} /> */}
                                                    <input type="text" ref="user_birthday" placeholder="Birthday" />
                                                </div>
                                            </div>
                                        </div>
                                        <div id="user_mail">
                                            <label>Email</label>
                                            <input type="text" ref="user_mail" placeholder="Email" />
                                        </div>
                                        <div id="user_phone">
                                            <label>Phone</label>
                                            <input type="number" ref="user_phone" placeholder="Phone" onWheel={(e) => $(e.target).blur()} />
                                        </div>
                                        <div id="user_address">
                                            <label>Address</label>
                                            <input type="text" ref="user_address" placeholder="Address" />
                                        </div>
                                        <button id="update_profile_submit" onClick={this.profileUpdate.bind(this)}>Save Profile</button>
                                    </div>
                                </div>
                            </div>
                            <div className="password_update_form">
                                <div className="form">
                                    <div className="form_header">
                                        <span>Change Password</span>
                                        <i className="fa fa-times" aria-hidden="true" onClick={this.resetFormAndClose.bind(this)}></i>
                                    </div>
                                    <div className="form_detail">
                                        <div id="old_pass">
                                            <input type="password" ref="old_pass" placeholder="Old Password" />
                                        </div>
                                        <div id="new_pass">
                                            <input type="password" ref="new_pass" placeholder="New Password" />
                                        </div>
                                        <div id="re_pass">
                                            <input type="password" ref="re_pass" placeholder="Re-enter New Password" />
                                        </div>
                                        <button id="change_pass_submit" onClick={this.passwordUpdate.bind(this)}>Save Password</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="maill_setting">

                </div>
            </div >
        )
    }
}
export default connect(
    state => ({
        ...state.profile
    }),
    dispatch => ({
        getProfile: () => dispatch(getProfile()),
        setVar: (key, value) => dispatch(setVar(key, value))
    })
)(Setting)


// WEBPACK FOOTER //
// ./src/components/user/setting/index.js